import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {JaarrapportageEntity, ClientEntity, ToelichtingenJaarrekening} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-nubbv',
  templateUrl: './nubbv.component.html',
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ],
  styleUrls: ['./nubbv.component.scss']
})
export class NubbvComponent implements OnInit {

  @Input() public id!: string;
  public textFg = {} as FormGroup;
  public taxPayer = {} as ClientEntity;
  public JaarrapportageEntity = {} as JaarrapportageEntity;
  public year: number | undefined = {} as number;

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private fb: FormBuilder) {
    this.textFg = this.fb.group<ToelichtingenJaarrekening>({
      toelichtingNietUitDeBalansBlijkendeVerplichtingen: null as unknown as string,
    })
  }

  ngOnInit(): void {
    this.algDataService.client.subscribe((value) => {
      this.taxPayer = value;
    });
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.JaarrapportageEntity = value;
      this.year = value.year;
    });
  }

  saveForm(): void {
    const updatedEntity= {
      ...this.JaarrapportageEntity,
    } as JaarrapportageEntity;
    this.jrDataService.updateEntity(updatedEntity);
  }
}
